import { render, staticRenderFns } from "./PreviewPostTiktok.vue?vue&type=template&id=ddecea7a&scoped=true&"
import script from "./PreviewPostTiktok.vue?vue&type=script&lang=js&"
export * from "./PreviewPostTiktok.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPostTiktok.vue?vue&type=style&index=0&id=ddecea7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddecea7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBadge,VIcon,VImg})
